import template from './form.html';
import nuevoClienteTemplate from '../../citas/form/cliente.nuevo.html';
import { FormActions } from 'core/services/form';
import atributoClienteI18N from 'i18n/atributos-cliente/es.json';
import commonI18N from 'i18n/common/es.json';
import { formatErrorMessage } from 'core/util';
import { rest } from 'core/api';

export let AtributoClienteFormComponent = {
  templateUrl: template,
  selector: 'atributoClienteForm',
  bindings: {
    view: '<',
    translations: '='
  },
  controller: FormController,
  controllerAs: 'vm'
};

export const translationKeys = Object.keys(atributoClienteI18N).concat(Object.keys(commonI18N));


FormController.$inject = ['$state', '$ngRedux', 'ngNotify', '$stateParams', 'Filter', 'BasicFactory', 'CustomModal', '$timeout', '$scope'];

function FormController($state, $ngRedux, ngNotify, $stateParams, Filter, BasicFactory, CustomModal, $timeout, $scope) {
  this.cancel = cancel.bind(this);
  this.doSubmit = doSubmit.bind(this);
  this.handleStatus = handleStatus.bind(this);
  this.mapStateToThis = mapStateToThis.bind(this);
  let unsubscribe;

  this.localModel = {
    nextPage: 'home.atributos-cliente.list',
    nextPageParams: {}
  };

  this.loadClientes = loadClientes.bind(this);
  this.renderCliente = renderCliente.bind(this);
  this.loadTipoAtributo = loadTipoAtributo.bind(this);
  this.renderTipoAtributo = renderTipoAtributo.bind(this);
  this.nuevoCliente = nuevoCliente.bind(this);
  this.updateRazonSocial = updateRazonSocial.bind(this);


  const sexoQuery = Filter.path('tipo.codigo').eq('sexo');
  const tipoPersonaQuery = Filter.path('tipo.codigo').eq('tipo_persona');
  const tipoDocumentoQuery = Filter.path('tipo.codigo').eq('tipo_documento');

  const valoresFilter = sexoQuery.or(tipoDocumentoQuery).or(tipoPersonaQuery);


  // Clases para los tags de ngTagInput
  this.tagClasses = ['tag-item'];

  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);

    if ($stateParams.uid) {
      this.title = this.view ? this.translations['Ver atributo de cliente'] : this.translations['Editar atributo de cliente'];
      this.formEdit('atributos-cliente', $stateParams.uid);
    } else {
      this.title = this.translations['Nuevo atributo de cliente'];
      this.form();
    }

    console.log("# $onInit(): $stateParams.cliente");
    console.log($stateParams.cliente);
    let clienteParamNewTab = window.localStorage.clienteParamNewTab? JSON.parse(window.localStorage.clienteParamNewTab) : null;
    if ($stateParams.cliente) {
      this.model.cliente = $stateParams.cliente;
    } else if (clienteParamNewTab) {
      this.model.cliente = clienteParamNewTab;
    }

    $ngRedux.dispatch(rest.actions.valores.get({ filter: JSON.stringify(valoresFilter) }));
  };

  function mapStateToThis(state) {
    this.handleStatus(state);
    this.submitted = state.form.flags ? state.form.flags.submitted : false;
    this.tiposPersona = state.valores.data.filter((v) => v.tipo.codigo === 'tipo_persona');

    const model = state.form.model;
    const campos = (model && model.tipo && model.tipo.campos) || [];
    const valor = (model && model.valor) || {};
    campos.forEach(campo => {
      if (campo.esFecha && valor && valor[campo.text]) {
        valor[campo.text] = new Date(valor[campo.text]);
      }
    });
    return {
      form: state.form,
      model,
      tiposDocumento: state.valores.data.filter((v) => v.tipo.codigo === 'tipo_documento')
    };
  }

  /**
   * Función que se encarga de mostrar mensajes de error en base al estado actual
   *
   * @param {object} state
   */
  function handleStatus(state) {
    if (state.form.notFound) {
      const msg = `${this.translations['No existe el elemento con ID']} ${$stateParams.uid}`;
      ngNotify.set(msg, 'warn');
      $timeout(() => $state.go('home.atributos-cliente.list'));
      return;
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    if (state.form.created) {
      ngNotify.set(this.translations['Datos guardados correctamente'], 'success');
      if ($stateParams.uid) {
        $state.go(this.localModel.nextPage, this.localModel.nextPageParams);
      } else {
        if (this.localModel.continuar) {
          $state.go($state.current, this.localModel.nextPageParams, {reload: true});
        } else {
          $state.go(this.localModel.nextPage, this.localModel.nextPageParams);
        }
      }
    }

    if (state.sucursales.error) {
      ngNotify.set(state.sucursales.error.message, 'error');
    }

    if (state.roles.error) {
      ngNotify.set(state.roles.error.message, 'error');
    }
  }

  function renderCliente(cliente) {
    let detalle = cliente.numeroDocumento ? `<small><strong>(${cliente.numeroDocumento})</strong></small>` : '';
    return `${cliente.razonSocial} ${detalle}`;
  }

  function loadClientes(query) {
    let filter = Filter.path('activo').eq(true);

    if (query) {
      filter = filter.and(Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numeroDocumento').like(query))
        .or(Filter.path('tipoDocumento.value').like(query))
        .or(Filter.path('sexo.value').like(query))
        .or(Filter.path('telefono').like(query)));
    }
    BasicFactory.setup('clientes');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function loadTipoAtributo(query) {

    if (query) {
      var filter = Filter.path('nombre').like(query);
      filter = filter.or(Filter.path('abreviatura').like(query));
    }
    BasicFactory.setup('tipos-atributos-cliente');
    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  function renderTipoAtributo(tipo) {
    let detalle = tipo.abreviatura ? `<small><strong>(${tipo.abreviatura})</strong></small>` : '';
    return `${tipo.nombre} ${detalle}`;
  }

  function nuevoCliente() {
    let self = this;
    this.localModel.payload = {};
    CustomModal.open({
      title: 'Nuevo Cliente',
      size: 'lg',
      templateUrl: nuevoClienteTemplate,
      backdrop: 'static',
      keyboard: false,
      vm: this,
      payload: this.localModel.payload,
      ok: function() {
        $ngRedux.dispatch(rest.actions.clientes({}, { body: JSON.stringify(self.localModel.payload) },
          (err, data) => {
            if (!err && data && data.id) {
              self.model.cliente = data;
              ngNotify.set(self.translations['Nuevo Cliente Creado'], 'success');
            } else if (err) {
              ngNotify.set(err.message, 'warn');
            }
          }));
      }
    });
  }

  this.updateRUC = updateRUC.bind(this);
  function updateRUC() {
    this.localModel.payload.nombre = this.localModel.payload.ruc.nombre;
    this.localModel.payload.apellido = this.localModel.payload.ruc.apellido;
    this.localModel.payload.numeroDocumento = this.localModel.payload.ruc.numero;
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : '' } ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;

    if (this.localModel.payload.ruc.personaFisica) {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Física')[0];
    } else {
      this.localModel.payload.tipoPersona = this.tiposPersona.filter((v) => v.value === 'Jurídica')[0];
      this.localModel.payload.razonSocial = this.localModel.payload.ruc.razonSocial;
    }
  }

  this.loadRUC = loadRUC.bind(this);
  function loadRUC(query) {
    let filter;

    if (query) {
      filter = Filter.path('nombre').like(query)
        .or(Filter.path('apellido').like(query))
        .or(Filter.path('razonSocial').like(query))
        .or(Filter.path('numero').like(query));
    }

    BasicFactory.setup('ruc');

    return filter ? BasicFactory.all({ filter: JSON.stringify(filter) }) : BasicFactory.all();
  }

  this.renderRUC = renderRUC.bind(this);
  function renderRUC(ruc) {
    let numeroDoc = ruc.numero && ruc.digitoVerificador ? ruc.numero + "-" + ruc.digitoVerificador : 'Sin Nro. Documento';
    return `${ruc.razonSocial} <small><strong>(${numeroDoc})</strong></small>`;
  }


  function updateRazonSocial() {
    this.localModel.payload.razonSocial = `${this.localModel.payload.nombre ? this.localModel.payload.nombre : '' } ${this.localModel.payload.apellido ? this.localModel.payload.apellido : ''}`;
  }

  /**
   * Cancela el formulario y retorna al listado
   */
  function cancel() {
    $state.go('home.atributos-cliente.list');
  }

  function doSubmit(continuar) {
    console.log('[doSubmit]');
    if ($scope.atributoClienteForm.$invalid) {
      this.submitted = true;
      return;
    }

    // Dependiendo de si clickeo solo guardar, o guardar y continuar, setea la pagina a la que se redireccionara y los
    // paramertros a pasar. Ambos son utilizados en handleStatus() una vez creado el tipo de atributo.
    if (continuar) {
      this.localModel.nextPage = 'home.atributos-cliente.new';
      this.localModel.nextPageParams = {cliente: this.model.cliente};
    } else {
      this.localModel.nextPage = 'home.atributos-cliente.list';
      this.localModel.nextPageParams = {};
    }
    this.localModel.continuar = continuar;

    let {
      id,
      cliente: {id:clienteId},
      tipo: {id:tipoId},
      valor
    } = this.model;

    // Remover los campos vacios del valor, antes de enviar
    Object.keys(valor).forEach((key) => (!valor[key]) && delete valor[key]);

    let data = {
      id,
      cliente: {id:clienteId},
      tipo: {id:tipoId},
      valor,
      origen: 'FORMULARIO'
    };
    this.save('atributos-cliente', data);
  }
}



// WEBPACK FOOTER //
// ./src/components/atributos-cliente/form/form.component.js